import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { forEach } from '@angular/router/src/utils/collection';
import { SelectItem } from 'primeng/api';
import { CriptoService } from 'src/app/_handler/cripto.service';
import { InspectionsAuto } from 'src/app/_model/documents/inspectionsAuto';
import { FormsService } from 'src/app/_services/api_v1/forms.service';
import { InspectionsService } from 'src/app/_services/api_v1/inspections.service';
import { InspectionRulesService } from 'src/app/_services/api_v1/inspection-rules.service';
import { BreadcrumbService } from 'src/app/breadcrumb.service';

interface ProvinceOption extends SelectItem {
    restricted?: string;
}

interface VehicleClassOption extends SelectItem {
    tipo?: string;
    grupo?: string;
    brand?: string;
    model?: string;
    restricted?: string;
}

type DataProcessingStatus = 'IDLE' | 'LOADING' | 'ACCEPTED' | 'PENDING' | 'ERROR';

interface DataProcessingLookup {
    documentNumber: string;
    encryptedDocument: string;
}

@Component({
    selector: 'app-autoInspections',
    templateUrl: './autoInspections.component.html',
    styleUrls: ['./autoInspections.component.css']
})

export class AutoInspectionsComponent implements OnInit {
    inspectiosnM = new InspectionsAuto();
    typeIdentification: SelectItem[];
    typeAutoIdentification: SelectItem[];
    typeInfoAdd: SelectItem[];
    typeVehicleUse: SelectItem[];
    vehicleClassOptions;
    provinceOptions: ProvinceOption[] = [];
    optionsPredict = [];
    filteredProvinces: any[];
    filteredVehicleClasses: any[];
    uuid: string;
    serchfind: boolean = false;
    form: NgForm;
    Serial = 'No. F000001'
    ActiveForm = true;
    FinishForm = false;
    disabled = false;
    errorEmail: string = '';
    errorEmailBroker: string = '';
    errorContactTelefonNumber: string = '';
    plateBlocked = false;
    vehicleUseError: boolean = false;
    provinceCirculationError: boolean = false;
    provinceRestrictionError: boolean = false;
    vehicleValueError: boolean = false;
    vehicleValueLimitError: boolean = false;
    vehicleValueMessage: boolean = false;
    vehicleUseDisabled: boolean = false;
    commercialVehicle: boolean = false;
    vehicleUseTouched: boolean = false;
    provinceCirculationTouched: boolean = false;
    showApprovedInspectionMessage: boolean = false;

    particularUseMessage: string = "Vehículo de servicio particular, para transporte de personas sin fines lucrativos";
    commercialUseMessage: string = "Vehículo de servicio comercial o particular, utilizado para el transporte de materiales, mercancías o personas para cumplir con su actividad económica. Excluye vehículos de uso público, taxi, taxi amigo, taxi ejecutivo y vehículos para renta.";
    confirmationMessage: string = "En mi calidad de intermediario, manifiesto que entiendo claramente qué significa el uso del vehículo y que destinarlo en actividades distintas, puede conllevar la pérdida del derecho a la indemnización en caso de siniestro, y por tanto, me comprometo a transmitir esta información al tomador y asegurado de la póliza.";

    ligthVehicleLimit: number = 100000;
    heavyVehicleLimit: number = 70000;

    //Disclaimer
    disclaimer = false;
    disclaimer2 = false;
    disclaimer3 = false;
    disclaimer4 = false;
    disclaimer5 = false;
    disclaimer6 = false;
    disabledBtnDis = '';
    valueCheck = false;
    cancelDisclaimer = false;
    returnDisclaimer = false;
    showQuestions: boolean = false;
    isDigitalInspection: boolean = false;
    showConfirmationModal: boolean = false;
    rulesResponse: any[] = [];
    provincesResponse: any[] = [];
    vehicleRestrictedResponse: any[] = [];
    isCurrentInspectionDigital: boolean = false;
    dataProtectionAccepted = false;
    dataProtectionModalOpen = false;
    dataProcessingStatus: DataProcessingStatus = 'IDLE';
    dataProcessingError = '';
    customerLookupError = '';
    deceasedCustomerModalOpen = false;
    inspectionSubmissionInProgress = false;
    private user: any;
    private encryptedLookupDocument = '';
    private dataProcessingLookupKey = '';
    private dataProcessingRequestId = 0;
    private readonly dataProcessingBranch = 'AUTOS';

    constructor(
        private inspectionService: InspectionsService,
        private inspectionRulesService: InspectionRulesService,
        private formService: FormsService,
        private breadcrumbService: BreadcrumbService,
        private criptoService: CriptoService,
        private elementRef: ElementRef,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.inspectiosnM.documentNumber = '';
    }
    async ngOnInit() {
        this.chargeBreadCrum();
        this.getProvinces();
        this.getVehicleClasses();
        this.loadInspectionRules();

        this.inspectiosnM.isSameContact = 'true';
        this.typeIdentification = [
            { label: 'Cédula de Identidad', value: 'Cedula' },
            { label: 'RUC', value: 'RUC' },
            { label: 'Pasaporte', value: 'Pasaporte' },

        ];
        this.typeAutoIdentification = [
            { label: 'Particular', value: 'PLACA' },
            // { label: 'RAMv', value: 'RAMV' },

        ]
        this.typeInfoAdd = [
            { label: 'Nueva', value: 'NUEVA' },
            { label: 'Re-inspección de daños', value: 'RE INSPECCION' },
            { label: 'Inclusión de accesorios', value: 'INCLUSIÓN ACCESORIOS' }
        ]
        if (!this.typeVehicleUse) {
            this.typeVehicleUse = [
                { label: 'Particular', value: 'PARTICULAR' },
                { label: 'Comercial', value: 'COMERCIAL' }
            ];
        }

        const accessToken = sessionStorage.getItem('access_token');
        this.user = accessToken ? JSON.parse(accessToken).user : null;
        this.getDataBroker();
        this.inspectiosnM.documentNumber = '';
        this.inspectiosnM.contactTelefonNumber = '';
        this.inspectiosnM.documentType = 'Cedula';
        this.inspectiosnM.plateType = 'PLACA';
        this.inspectiosnM.use = '';
        this.inspectiosnM.vehicleValue = '';
        this.vehicleUseError = false;
        this.valueCheck = false;
        this.inspectiosnM.provinceCirculation = '';
        this.provinceCirculationError = false;
        this.provinceRestrictionError = false;
        this.vehicleValueError = false;
        this.vehicleValueLimitError = false;
        this.vehicleValueMessage = false;

    }
    valitatePlate() {
        const regexp = new RegExp(/^[A-Z]{3}-\d{4}/);
        if (regexp.test(this.inspectiosnM.plateNumber) && this.inspectiosnM.plateType != null) {
            this.validateVehicleAndDataProcessing();
        } else {
            this.gotoDisclaimer();
        }
    }

    validateVehicleAndDataProcessing(): void {
        this.getPlateOrRamv();
        this.checkDataProcessingStatus();
    }

    onDocumentNumberChange(): void {
        this.changePlate();
        this.resetDataProcessingState();
    }

    private checkDataProcessingStatus(): void {
        if (!this.user) {
            this.resetDataProcessingState();
            this.dataProcessingStatus = 'ERROR';
            this.dataProcessingError = 'No fue posible obtener la información de sesión.';
            return;
        }

        const lookup = this.getDataProcessingLookup();
        const lookupKey = lookup ? this.getDataProcessingLookupKey(lookup.documentNumber) : '';
        if (lookupKey === this.dataProcessingLookupKey) {
            return;
        }

        this.resetDataProcessingState();
        if (!lookup) {
            return;
        }

        this.dataProcessingLookupKey = lookupKey;
        this.encryptedLookupDocument = lookup.encryptedDocument;
        this.dataProcessingStatus = 'LOADING';
        const requestId = ++this.dataProcessingRequestId;
        this.formService.getDataProcessingAcceptance(
            this.getDataProcessingStatusDocumentType(),
            lookup.encryptedDocument,
            this.user.brokerId,
            this.dataProcessingBranch
        ).subscribe(
            (response: any) => this.handleDataProcessingStatusResponse(response, requestId, lookupKey),
            () => this.handleDataProcessingStatusError(requestId, lookupKey)
        );
    }

    private handleDataProcessingStatusResponse(response: any, requestId: number, lookupKey: string): void {
        if (!this.isCurrentDataProcessingRequest(requestId, lookupKey)) {
            return;
        }

        const status = String(response && response.status || '').toUpperCase();
        if (status === 'ACEPTADO') {
            this.dataProcessingStatus = 'ACCEPTED';
            return;
        }
        if (status === 'PENDIENTE') {
            this.dataProcessingStatus = 'PENDING';
            return;
        }

        this.dataProcessingStatus = 'ERROR';
        this.dataProcessingError = 'No fue posible validar la autorización de uso de datos.';
    }

    private handleDataProcessingStatusError(requestId: number, lookupKey: string): void {
        if (!this.isCurrentDataProcessingRequest(requestId, lookupKey)) {
            return;
        }

        this.dataProcessingStatus = 'ERROR';
        this.dataProcessingError = 'No fue posible validar la autorización de uso de datos.';
    }

    private isCurrentDataProcessingRequest(requestId: number, lookupKey: string): boolean {
        return requestId === this.dataProcessingRequestId && lookupKey === this.dataProcessingLookupKey;
    }

    private getDataProcessingLookup(): DataProcessingLookup | null {
        if (!this.requiresDataProcessing()) {
            return null;
        }

        const documentNumber = String(this.inspectiosnM.documentNumber || '').trim();
        const lookupDocument = this.inspectiosnM.documentType === 'RUC' ? documentNumber.substring(0, 10) : documentNumber;
        if (this.inspectiosnM.documentType === 'Cedula' && lookupDocument.length !== 10) {
            return null;
        }
        if (this.inspectiosnM.documentType === 'RUC' && (documentNumber.length < 10 || lookupDocument.length !== 10)) {
            return null;
        }
        if (this.inspectiosnM.documentType === 'Pasaporte' && lookupDocument.length < 3) {
            return null;
        }

        return { documentNumber: lookupDocument, encryptedDocument: this.criptoService.set(lookupDocument) };
    }

    private requiresDataProcessing(): boolean {
        return this.inspectiosnM.documentType === 'Cedula' ||
            this.inspectiosnM.documentType === 'Pasaporte' ||
            (this.inspectiosnM.documentType === 'RUC' && this.inspectiosnM.personType === 'N');
    }

    private requiresCustomerLookup(): boolean {
        return this.inspectiosnM.documentType === 'Cedula' ||
            (this.inspectiosnM.documentType === 'RUC' && this.inspectiosnM.personType === 'N');
    }

    private getDataProcessingStatusDocumentType(): number | string {
        return this.inspectiosnM.documentType === 'Pasaporte' ? 'P' : 1;
    }

    private getDataProcessingAcceptanceDocumentType(): string {
        return this.inspectiosnM.documentType === 'Pasaporte' ? 'P' : 'C';
    }

    private getDataProcessingLookupKey(documentNumber: string): string {
        return `${this.inspectiosnM.documentType}-${documentNumber}-${this.user.brokerId}-${this.dataProcessingBranch}`;
    }

    private resetDataProcessingState(): void {
        this.dataProcessingRequestId++;
        this.dataProcessingLookupKey = '';
        this.encryptedLookupDocument = '';
        this.dataProcessingStatus = 'IDLE';
        this.dataProcessingError = '';
        this.customerLookupError = '';
        this.dataProtectionAccepted = false;
        this.dataProtectionModalOpen = false;
        this.inspectionSubmissionInProgress = false;
    }

    private buildDataProcessingAcceptanceRequest(): any {
        return {
            documentNumber: this.encryptedLookupDocument,
            documentType: this.getDataProcessingAcceptanceDocumentType(),
            ramo: this.dataProcessingBranch,
            rucBroker: this.user.brokerId,
            email: this.user.email
        };
    }

    private buildDataProcessingCustomerRequest(): any {
        return {
            documentNumber: this.encryptedLookupDocument,
            documentType: '1',
            ramo: this.dataProcessingBranch,
            rucBroker: this.user.brokerId
        };
    }

    private cannotContinueWithCustomer(customer: any): boolean {
        const citizenCondition = String(customer.citizenCondition || '').trim().toUpperCase();
        return Boolean(customer.deathDate) || citizenCondition === 'FALLECIDO' || citizenCondition === 'FALLECIDA';
    }

    closeDeceasedCustomerModal(): void {
        this.deceasedCustomerModalOpen = false;
        window.location.reload();
    }

    chargeBreadCrum() {
        this.breadcrumbService.setItems([
            { label: 'Inicio', routerLink: ['/home'] },
            { label: 'Gestión de solicitudes' },
            { label: 'Nueva inspección de vehículo', routerLink: ['/autoInspections'] }
        ]);
    }

    openDataProtectionModal(): void {
        this.dataProtectionModalOpen = true;
    }

    acceptDataProtection(): void {
        this.dataProtectionAccepted = true;
        this.dataProtectionModalOpen = false;
    }

    shouldShowDataProtectionConsent(): boolean {
        return this.requiresDataProcessing() && this.dataProcessingStatus === 'PENDING';
    }

    canSubmitDataProcessing(): boolean {
        if (!this.requiresDataProcessing()) {
            return true;
        }

        return this.dataProcessingStatus === 'ACCEPTED' ||
            (this.dataProcessingStatus === 'PENDING' && this.dataProtectionAccepted);
    }

    prepareForm(form: NgForm): void {
        if (!form.valid || !this.canSubmitDataProcessing() || this.inspectionSubmissionInProgress) {
            return;
        }

        if (this.inspectiosnM.use && !this.valueCheck) {
            return;
        }

        const selectedProvince = this.inspectiosnM.provinceCirculation ? this.inspectiosnM.provinceCirculation.toUpperCase() : '';
        const isGalapagos = selectedProvince === 'GALAPAGOS ISABELA' ||
            selectedProvince === 'GALAPAGOS SANTA CRUZ' ||
            selectedProvince === 'GALAPAGOS SAN CRISTOBAL';
        if (isGalapagos) {
            this.provinceRestrictionError = true;
            return;
        }

        this.inspectionSubmissionInProgress = true;
        this.customerLookupError = '';
        if (this.dataProcessingStatus === 'PENDING') {
            this.saveDataProcessingAcceptance();
            return;
        }

        this.validateCustomerBeforeSubmission();
    }

    private saveDataProcessingAcceptance(): void {
        this.formService.postDataProcessingAcceptance(this.buildDataProcessingAcceptanceRequest()).subscribe(
            () => {
                this.dataProcessingStatus = 'ACCEPTED';
                this.validateCustomerBeforeSubmission();
            },
            () => this.handleSubmissionError('No fue posible registrar la aceptación de uso de datos.')
        );
    }

    private validateCustomerBeforeSubmission(): void {
        if (!this.requiresCustomerLookup()) {
            this.submitInspection();
            return;
        }

        this.formService.postDataProcessingCustomer(this.buildDataProcessingCustomerRequest()).subscribe(
            (response: any) => {
                if (!response || !response.firstName) {
                    this.handleSubmissionError('Número de documento no encontrado.');
                    return;
                }

                if (this.cannotContinueWithCustomer(response)) {
                    this.inspectionSubmissionInProgress = false;
                    this.deceasedCustomerModalOpen = true;
                    return;
                }

                this.submitInspection();
            },
            () => this.handleSubmissionError('No fue posible consultar los datos del cliente.')
        );
    }

    private submitInspection(): void {
        const digitalInspectionResult = this.validateDigitalInspection();
        this.inspectiosnM['vehicleDigitalInspection'] = digitalInspectionResult.digitalInspection;
        this.isDigitalInspection = digitalInspectionResult.digitalInspection;
        const inspectionData = {
            ...this.inspectiosnM,
            vehicleGroup: this.inspectiosnM.vehicleGroup,
            vehiclePlaceCirculation: this.inspectiosnM.provinceCirculation,
            vehicleTypeInspection: digitalInspectionResult.digitalInspection ? 'digital' : 'presencial',
            vehicleUse: this.inspectiosnM.use,
            vehicleClass: this.inspectiosnM.vehicleType
        };

        this.inspectionService.postInspections(inspectionData).subscribe(
            (response) => this.handleInspectionSubmissionResponse(response, inspectionData),
            () => this.handleSubmissionError('No fue posible registrar la solicitud de inspección.')
        );
    }

    private handleInspectionSubmissionResponse(response: any, inspectionData: any): void {
        this.inspectionSubmissionInProgress = false;
        if (response.code === 7 || response.estado === 'APROBADA') {
            this.showApprovedInspectionMessage = true;
            this.showConfirmationModal = true;
            this.disclaimer6 = true;
        } else {
            switch (response.code) {
                case 6:
                    localStorage.setItem('inspectionFormData', JSON.stringify(inspectionData));
                    this.showQuestions = true;
                    this.ActiveForm = false;
                    break;
                case 5:
                    this.disclaimer5 = true;
                    break;
                case 4:
                    this.disclaimer3 = true;
                    break;
                case 3:
                    this.Serial = response.sequencial;
                    this.router.navigate(['/inspectionsCreated'], {
                        queryParams: { inspectionId: response.sequencial }
                    });
                    break;
                case 2:
                    this.goToStep4();
                    break;
                case 1:
                    this.disclaimer2 = true;
                    break;
                default:
                    break;
            }
        }

        window['dataLayer'].push({
            event: 'button_click',
            result: 'Success',
            params: this.inspectiosnM
        });
    }

    private handleSubmissionError(message: string): void {
        this.inspectionSubmissionInProgress = false;
        this.customerLookupError = message;
    }
    reInspection() {
        this.disclaimer3 = false
        const digitalInspectionResult = this.validateDigitalInspection();
        this.inspectiosnM['vehicleDigitalInspection'] = digitalInspectionResult.digitalInspection;
        this.isDigitalInspection = digitalInspectionResult.digitalInspection;
        this.inspectiosnM.reInspection = true;
        this.inspectiosnM.inspectionType = "RE INSPECCION";
        const inspectionData = {
            ...this.inspectiosnM,
            vehicleGroup: this.inspectiosnM.vehicleGroup,
            vehiclePlaceCirculation: this.inspectiosnM.provinceCirculation,
            vehicleTypeInspection: digitalInspectionResult.digitalInspection ? 'digital' : 'presencial',
            vehicleUse: this.inspectiosnM.use,
            vehicleClass: this.inspectiosnM.vehicleType
        };
        this.inspectionService.postInspections(inspectionData).subscribe((response) => {
            switch (response.code) {
                case 6:
                    localStorage.setItem('inspectionFormData', JSON.stringify(inspectionData));
                    this.showQuestions = true;
                    this.ActiveForm = false;
                    break;
                case 3:
                    this.Serial = response.sequencial;
                    this.gotoFinish();
                    this.disclaimer3 = false
                    window['dataLayer'].push({
                        event: 'button_click',
                        result: 'Success',
                        params: this.inspectiosnM
                    });
                    this.router.navigate(['/autoInspections'], {
                        queryParams: { inspectionId: response.sequencial }
                    })
                    break;
                default:
                    break;
            }
        })
    }
    getDataBroker() {
        if (!this.user) {
            return;
        }

        this.inspectiosnM.brokerEmail = this.user.email;
        this.inspectiosnM.brokerName = this.user.brokerName;
        this.inspectiosnM.brokerRuc = this.user.brokerId;
    }
    getProvinces() {
        this.provinceOptions = [];
        let provincia = this.inspectionService.listRestrictedProvince().subscribe((data) => {
            if (data && data.allProvinces && data.allProvinces.length > 0) {
                data.allProvinces.forEach(dataValue => {
                    let item = {
                        value: dataValue.Dept_City,
                        label: dataValue.Dept_City,
                        restricted: dataValue.restricted || 'NO'
                    };
                    this.provinceOptions.push(item);
                });
            }
        });
    }

    getVehicleClasses() {
        this.inspectionService.listRestrictedlistTClase().subscribe((response) => {
            if (Array.isArray(response)) {
                this.vehicleClassOptions = response;
                if (this.inspectiosnM.vehicleCategory && this.vehicleClassOptions) {
                    const subClase = this.normalizeString(this.inspectiosnM.vehicleCategory);
                    const matchingVehicle = this.vehicleClassOptions.find(item => {
                        const vehiculoClase = item.VehiculoClase ? this.normalizeString(item.VehiculoClase) : '';
                        const clase = item.Clase ? this.normalizeString(item.Clase) : '';
                        return vehiculoClase === subClase || clase === subClase;
                    });

                    if (matchingVehicle) {

                        this.inspectiosnM.vehicleGroup = matchingVehicle.Grupo;
                        this.inspectiosnM.vehicleType = matchingVehicle.Tipo;

                        if (this.isHeavyVehicle()) {
                            this.commercialVehicleUse();
                        }
                    }
                }
            } else {
                if (response && typeof response === 'object') {
                    for (const key in response) {
                        if (Array.isArray(response[key])) {
                            this.vehicleClassOptions = response[key];

                            if (this.inspectiosnM.vehicleCategory) {
                                const subClase = this.normalizeString(this.inspectiosnM.vehicleCategory);

                                const matchingVehicle = this.vehicleClassOptions.find(item => {
                                    const vehiculoClase = item.VehiculoClase ? this.normalizeString(item.VehiculoClase) : '';
                                    const clase = item.Clase ? this.normalizeString(item.Clase) : '';
                                    return vehiculoClase === subClase || clase === subClase;
                                });

                                if (matchingVehicle) {
                                    this.inspectiosnM.vehicleGroup = matchingVehicle.Grupo;
                                    this.inspectiosnM.vehicleType = matchingVehicle.Tipo;

                                    if (this.isHeavyVehicle()) {
                                        this.commercialVehicleUse();
                                    }
                                }
                            }
                            break;
                        }
                    }
                }
            }
        });
    }

    private normalizeString(str: string): string {
        return str.toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^A-Z0-9]/g, '');
    }

    getPlateOrRamv(ramv?) {
        let plate = this.inspectiosnM.plateNumber.replace(/[^a-zA-Z0-9]/g, "-");
        this.inspectionService.getInspectionsPlateOrRamv(true, this.inspectiosnM.plateType, plate, ramv ? ramv.query : '').subscribe((response) => {
            if (response == null || response == "") {
                this.disclaimer = true;
            } else if (response.errorDescripcion) {
                this.disclaimer = true;
            } else if (response == "Blocked") {
                this.plateBlocked = true;
            } else {
                this.plateBlocked = false;
                this.inspectiosnM.vehicleValue = response.autPrecioComercial;
                if (response.autPrecioComercial && response.autPrecioComercial > 0) {
                    this.vehicleValueError = false;
                }
                this.inspectiosnM.chassisNumber = response.autSerialVinChasis;
                this.inspectiosnM.engineNumber = response.autNumeroMotor;
                this.inspectiosnM.vehicleBrand = response.autMarca;
                this.inspectiosnM.vehicleModel = response.autModelo;
                this.inspectiosnM.vehicleType = response.autClase;
                this.inspectiosnM.vehicleCategory = response.autNombreSubClase == null || response.autNombreSubClase == "" ? response.autClase : response.autNombreSubClase;
                this.inspectiosnM.vehicleGroup = response.autCodigoTipoServicio;
                this.inspectiosnM.yearManufacture = response.autAnioModelo;

                this.getVehicleClasses();

                setTimeout(() => {
                    this.commercialVehicleUse();

                    if (this.inspectiosnM.vehicleValue) {
                        this.formatVehicleValue();
                    }
                    this.vehicleValueMessage = true;
                }, 100);
            }
        }, (error) => {
            this.disclaimer = true;
        });
    }

    getVehicleClassData() {
        if (!this.inspectiosnM.vehicleBrand || !this.inspectiosnM.vehicleType) {
            return;
        }

        this.inspectionService.listRestrictedlistTClase().subscribe((response) => {

            if (response && Array.isArray(response)) {
                const matchingVehicle = response.find(item =>
                    (item['VehiculoClase'] && item['VehiculoClase'].toUpperCase() === this.inspectiosnM.vehicleType.toUpperCase()) ||
                    (item.Clase && item.Clase.toUpperCase() === this.inspectiosnM.vehicleType.toUpperCase())
                );

                if (matchingVehicle) {

                    if (matchingVehicle.Grupo) {
                        this.inspectiosnM.vehicleGroup = matchingVehicle.Grupo;

                        const isPesado = this.isHeavyVehicle();

                        if (isPesado) {
                            this.commercialVehicleUse();
                        }
                    }
                } else {

                    if (this.isHeavyVehicle()) {
                        this.commercialVehicleUse();
                    }
                }
            }
        }, error => {
            if (this.isHeavyVehicle()) {
                this.commercialVehicleUse();
            }
        });
    }

    getPlateOrRamv1(ramv?) {
        this.inspectionService.getInspectionsPlateOrRamv(false, this.inspectiosnM.plateType, this.inspectiosnM.plateNumber, ramv ? ramv.query : '').subscribe((response) => {
            this.optionsPredict = response
        })
    }
    onChangeSelect() {
        this.inspectiosnM.vehicleBrand = ''
        this.inspectiosnM.vehicleModel = ''
        this.inspectiosnM.vehicleType = ''
        this.inspectiosnM.vehicleGroup = ''
        this.inspectiosnM.yearManufacture = ''
    }
    onChangeSelectContact() {
        this.inspectiosnM.contactEmail = ''
        this.inspectiosnM.contactName = ''
        this.inspectiosnM.contactSurName = ''
        this.inspectiosnM.contactTelefonNumber = ''
    }
    onChangeSelectTypeIdentification() {
        this.resetDataProcessingState();
        this.inspectiosnM.documentNumber = '';
        this.inspectiosnM.name = '';
        this.inspectiosnM.surname = '';
        this.inspectiosnM.middleName = '';
        this.inspectiosnM.middleSurame = '';
        this.inspectiosnM.companyName = '';
    }

    RamvFig() {
        this.inspectiosnM.use = 'personal'
        this.inspectiosnM.vehicleValue = this.inspectiosnM.searchVehicle.Valor
        this.inspectiosnM.chassisNumber = null
        this.inspectiosnM.engineNumber = null
        this.inspectiosnM.vehicleCategory = this.inspectiosnM.searchVehicle.Categotia3
        this.inspectiosnM.vehicleBrand = this.inspectiosnM.searchVehicle.Marca
        this.inspectiosnM.vehicleModel = this.inspectiosnM.searchVehicle.Modelo
        this.inspectiosnM.vehicleType = this.inspectiosnM.searchVehicle.Tipo
        this.inspectiosnM.vehicleGroup = this.inspectiosnM.searchVehicle.Grupo
        this.inspectiosnM.yearManufacture = this.inspectiosnM.searchVehicle.Year
    }

    isEvent(event: KeyboardEvent) {
        if (this.inspectiosnM.contactEmail == null || this.inspectiosnM.contactEmail.trim().length == 0 || this.inspectiosnM.contactEmail == '') {
            this.errorEmail = 'Este campo no puede quedar vacío';
            return false
        } else if (this.inspectiosnM.contactEmail != null || this.inspectiosnM.contactEmail != '') {
            this.errorEmail = 'El correo electrónico ingresado no tiene el formato correcto';
            let regexp = new RegExp(/^[a-zA-Z0-9\._-]{1,64}@([a-zA-Z0-9\.]{1,35})(\.com|\.org|\.net|\.co|\.ec)$/);
            return regexp.test(this.inspectiosnM.contactEmail);
        }
    }
    isEventTel() {
        if (this.inspectiosnM.contactTelefonNumber == '') {
            this.errorContactTelefonNumber = 'Debes ingresar un número de contacto';
            return false
        } else if (this.inspectiosnM.contactTelefonNumber.length < 9 && this.inspectiosnM.contactTelefonNumber.length >= 1) {
            this.errorContactTelefonNumber = 'El numero ingresado no cuenta con el formato correcto';
            return false;
        }
        else {
            return true
        }
    }
    isEventBroker(event: KeyboardEvent) {
        if (this.inspectiosnM.brokerEmail == null || this.inspectiosnM.brokerEmail.trim().length == 0 || this.inspectiosnM.brokerEmail == '') {
            this.errorEmailBroker = 'Este campo no puede quedar vacío';
            return false
        } else if (this.inspectiosnM.brokerEmail != null || this.inspectiosnM.brokerEmail != '') {
            this.errorEmailBroker = 'El correo electrónico ingresado no tiene el formato correcto';
            let regexp = new RegExp(/^[a-zA-Z0-9\._-]{1,64}@([a-zA-Z0-9\.]{1,35})(\.com|\.org|\.net|\.co|\.ec)$/);
            return regexp.test(this.inspectiosnM.brokerEmail);
        }
    }

    removeLastThreeDigits(string) {
        const stringLength = string.length - 3;
        const stringWithoutLastThreeDigits = string.substring(0, stringLength);
        return stringWithoutLastThreeDigits;
    }

    validateCi(number) {
        const idNumber = this.removeLastThreeDigits(number);
        if (idNumber.length === 10) {
            var total = 0;
            var longitud = idNumber.length;
            var longcheck = longitud - 1;
            if (idNumber !== "" && longitud === 10) {
                for (let i = 0; i < longcheck; i++) {
                    if (i % 2 === 0) {
                        var aux = idNumber.charAt(i) * 2;
                        if (aux > 9) aux -= 9;
                        total += aux;
                    } else {
                        total += parseInt(idNumber.charAt(i));
                    }
                }
                total = total % 10 ? 10 - total % 10 : 0;
                return idNumber.charAt(longitud - 1) == total
            }
        } else {
            return false;
        }
    }

    identificarTipoRUC(ruc, personType) {
        ruc = ruc.replace(/\D/g, '');
        if (ruc.length !== 13) {
            return false;
        }
        const tercerDigito = ruc.charAt(2);
        if (personType == 'J' && (tercerDigito === '6' || tercerDigito === '9')) {
            return true;
        } else if (personType == 'N') {
            return this.validateCi(ruc);
        } else {
            return false;
        }
    }

    validarCedula() {
        const docNum = this.inspectiosnM.documentNumber;
        const docTyp = this.inspectiosnM.documentType;
        const regEx = /^[0-9]{10}$/;
        if (docNum.length == 13 && docTyp == 'RUC') {
            if (this.inspectiosnM.personType == 'J' || this.inspectiosnM.personType == 'N') {
                return this.identificarTipoRUC(docNum, this.inspectiosnM.personType);
            } else {
                return false
            }
        } else if (docNum.length == 13 && docTyp == 'Pasaporte') {
            // Verificar si el RUC tiene 13 caracteres
            if (docNum.length !== 13) return false;

            // Verificar si los primeros dos dígitos son válidos para Ecuador
            const provincia = parseInt(docNum.substring(0, 2), 10);
            if (provincia < 1 || provincia > 24) return false;

            // Verificar tercer dígito para tipo de contribuyente
            // 6 para entidades públicas, 9 para sociedades privadas y extranjeros sin cédula, y menos de 6 para personas naturales
            const tercerDigito = parseInt(docNum.charAt(2), 10);
            if (tercerDigito !== 6 && tercerDigito !== 9 && tercerDigito >= 6) return false;

            // Aplicar algoritmo de módulo 11 para validar dígito verificador para entidades públicas y privadas
            // Aplicar algoritmo de módulo 10 para personas naturales
            let suma = 0;
            const coeficientesMod11 = [4, 3, 2, 7, 6, 5, 4, 3, 2];
            const coeficientesMod10 = [2, 1, 2, 1, 2, 1, 2, 1, 2];

            for (let i = 0; i < 9; i++) {
                const digito = parseInt(docNum.charAt(i), 10);
                if (tercerDigito === 6 || tercerDigito === 9) {
                    suma += coeficientesMod11[i] * digito;
                } else {
                    let valor = coeficientesMod10[i] * digito;
                    if (valor >= 10) valor -= 9;
                    suma += valor;
                }
            }

            let digitoVerificador;
            if (tercerDigito === 6 || tercerDigito === 9) {
                const modulo = suma % 11;
                digitoVerificador = modulo === 0 ? 0 : 11 - modulo;
            } else {
                const modulo = suma % 10;
                digitoVerificador = modulo === 0 ? 0 : 10 - modulo;
            }

            // El dígito verificador es el décimo dígito del RUC para entidades públicas y privadas
            // y el último dígito para personas naturales
            if (tercerDigito === 6 || tercerDigito === 9) {
                return digitoVerificador === parseInt(docNum.charAt(9), 10);
            } else {
                return digitoVerificador === parseInt(docNum.charAt(9), 10);
            }

        } else if (docNum.length == 10 && docTyp == 'Cedula') {
            if (!regEx.test(docNum)) {
                return false;
            }

            const digitoRegion = parseInt(docNum.substring(0, 2));

            if (digitoRegion < 1 || digitoRegion > 24) {
                return false;
            }

            const ultimoDigito = parseInt(docNum.substring(9, 10));
            const pares = parseInt(docNum.substring(1, 2)) + parseInt(docNum.substring(3, 4)) +
                parseInt(docNum.substring(5, 6)) + parseInt(docNum.substring(7, 8));

            let impares = 0;
            for (let i = 0; i < 9; i += 2) {
                let numero = parseInt(docNum.charAt(i)) * 2;
                if (numero > 9) {
                    numero -= 9;
                }
                impares += numero;
            }

            const sumaTotal = pares + impares;
            const primerDigitoSuma = parseInt(String(sumaTotal).charAt(0));
            const decena = (primerDigitoSuma + 1) * 10;
            let digitoValidador = decena - sumaTotal;

            if (digitoValidador === 10) {
                digitoValidador = 0;
            }

            return digitoValidador === ultimoDigito;
        }

    }
    goToStep4() {
        this.disclaimer4 = true;
    }

    async hidenDisclaimer(form: NgForm) {
        this.disclaimer = false;
        this.disclaimer2 = false;
        this.disclaimer3 = false;
        this.disclaimer4 = false;
        this.disclaimer5 = false;
        this.disclaimer6 = false;
        this.goToNewForm(form);
    }
    hidenDisclaimer1() {
        this.disclaimer = false;
    }
    gotoDisclaimer() {
        this.disclaimer = true;
    }

    gotoFinish() {
        this.ActiveForm = false;
        this.FinishForm = true;
    }

    goToNewForm(form?: NgForm) {
        this.inspectiosnM = new InspectionsAuto();
        this.getDataBroker();
        if (form) {
            form.resetForm({ broke_name: this.inspectiosnM.brokerName, broke_ruc: this.inspectiosnM.brokerRuc, brokerEmail: this.inspectiosnM.brokerEmail, Same_contact: 'true' })
        }

        this.resetDataProcessingState();
        this.dataProtectionModalOpen = false
        
        this.ActiveForm = true;
        this.FinishForm = false;
        this.inspectiosnM.documentNumber = '';
        this.inspectiosnM.isSameContact = 'true';
        this.inspectiosnM.contactTelefonNumber = '';

    }
    onChangeTypeDoc() {
        if (this.inspectiosnM.documentType != 'RUC' || this.inspectiosnM.personType != 'J') {
            this.onChangeSelectPersonFalse()
        } else if (this.inspectiosnM.documentType == 'RUC' && this.inspectiosnM.personType == 'J') {
            this.onChangeSelectPersonTrue()
        }
    }

    onChangeSelectPersonTrue() {
        this.disabled = true;
        this.inspectiosnM.isSameContact = 'false';
        this.onChangeSelectTypeIdentification();
    }
    onChangeSelectPersonFalse() {
        this.disabled = false;
        this.inspectiosnM.isSameContact = 'true';
        this.onChangeSelectTypeIdentification();
    }
    goToInit() {
        this.router.navigate(['/home'], { relativeTo: this.route });
    }

    changePlate() {
        this.plateBlocked = false;
    }

    maskInputPlate() {
        let regexp = new RegExp(/^[A-Z]+-+[0-9]{4}$/);
        return regexp.test(this.inspectiosnM.plateNumber);
    }

    onBlur() {
        const value = this.inspectiosnM.contactTelefonNumber;
        if (value.length === 9) {
            this.inspectiosnM.contactTelefonNumber = '0' + value;
        }
    }
    validateVehicleUse(): boolean {
        if (!this.inspectiosnM.use || this.inspectiosnM.use === '') {
            this.vehicleUseError = true;
            return false;
        }
        this.vehicleUseError = false;
        return true;
    }
    onChangeVehicleUse() {
        this.validateVehicleUse();
        if (!this.validateVehicleUse()) {
            this.valueCheck = false;
        }
    }
    onVehicleUseBlur() {
        this.vehicleUseTouched = true;
        if (!this.inspectiosnM.use) {
            this.vehicleUseError = true;
        }
    }
    onVehicleUseChange() {
        this.vehicleUseError = false;
        this.vehicleUseTouched = true;
    }
    validateProvinceCirculation(): boolean {
        if (this.provinceCirculationTouched && (!this.inspectiosnM.provinceCirculation || this.inspectiosnM.provinceCirculation === '')) {
            this.provinceCirculationError = true;
            this.provinceRestrictionError = false;
            return false;
        }

        if (String(this.inspectiosnM.provinceCirculation).toUpperCase().indexOf('GALAPAGOS') >= 0) {
            this.provinceCirculationError = false;
            this.provinceRestrictionError = true;
            return false;
        }

        this.provinceRestrictionError = false;
        this.provinceCirculationError = false;
        return true;
    }
    onProvinceCirculationBlur() {
        this.provinceCirculationTouched = true;
        if (!this.inspectiosnM.provinceCirculation) {
            this.provinceCirculationError = true;
        } else {
            this.provinceCirculationError = false;
        }
    }
    onProvinceCirculationChange() {
        this.provinceCirculationError = false;
        this.provinceCirculationTouched = true;
    }
    filterProvinces(event: any) {
        let query = event.query;
        this.filteredProvinces = [];
        if (query) {
            this.filteredProvinces = this.provinceOptions.filter(province =>
                province.label.toLowerCase().includes(query.toLowerCase()));
        } else {
            this.filteredProvinces = [...this.provinceOptions];
        }
        this.validateProvinceCirculation();
    }
    onProvinceSelect(event: any) {
        if (event && event.value) {
            const selectedProvince = event.value.toUpperCase();
            this.provinceRestrictionError = selectedProvince === 'GALAPAGOS ISABELA' ||
                selectedProvince === 'GALAPAGOS SANTA CRUZ' ||
                selectedProvince === 'GALAPAGOS SAN CRISTOBAL';
            this.provinceCirculationError = false;

        }
    }

    onProvinceBlur() {
        this.validateProvinceCirculation();
    }
    validateVehicleValue(): boolean {
        if (!this.inspectiosnM.vehicleValue || this.inspectiosnM.vehicleValue === '') {
            this.vehicleValueError = true;
            this.vehicleValueLimitError = false;
            return false;
        }

        const value = parseFloat(this.inspectiosnM.vehicleValue.toString().replace(/[$,.]/g, ''));

        if (isNaN(value) || value === 0) {
            this.vehicleValueError = true;
            this.vehicleValueLimitError = false;
            return false;
        }

        const isPesado = this.isHeavyVehicle();
        const valueLimit = this.getVehicleValueLimit();

        if (value > valueLimit) {
            this.vehicleValueError = false;
            this.vehicleValueLimitError = true;
            return false;
        }

        this.vehicleValueError = false;
        this.vehicleValueLimitError = false;
        return true;
    }

    formatVehicleValue() {
        if (this.inspectiosnM.vehicleValue) {
            let value = this.inspectiosnM.vehicleValue.toString().replace(/[$,.]/g, '');

            const numValue = parseFloat(value);
            if (!isNaN(numValue)) {
                this.inspectiosnM.vehicleValue = '$' + numValue.toLocaleString('es-ES', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                });
            }
        }
    }

    onVehicleValueFocus() {
        this.vehicleValueMessage = true;
        const currentValue = this.inspectiosnM.vehicleValue;
        if (this.inspectiosnM.vehicleValue) {
            const cleanValue = this.inspectiosnM.vehicleValue.toString().replace(/[$,.]/g, '');
            this.inspectiosnM.vehicleValue = cleanValue;
        }

        setTimeout(() => {
            const vehicleValueInput = document.getElementById('vehicleValue');
            if (vehicleValueInput) {
                vehicleValueInput.style.outline = 'none';
                vehicleValueInput.style.borderColor = '#919191';
                vehicleValueInput.style.borderWidth = '1px';
                vehicleValueInput.style.boxShadow = 'none';
            }
        }, 0);
    }

    onVehicleValueBlur() {
        if (!this.inspectiosnM.vehicleValue || this.inspectiosnM.vehicleValue === '' ||
            parseFloat(this.inspectiosnM.vehicleValue.toString().replace(/[$,.]/g, '')) === 0) {
            this.vehicleValueError = true;
            this.vehicleValueLimitError = false;

            if (this.inspectiosnM.vehicleValue &&
                parseFloat(this.inspectiosnM.vehicleValue.toString().replace(/[$,.]/g, '')) === 0) {
                this.formatVehicleValue();
            }
            return;
        }

        const value = parseFloat(this.inspectiosnM.vehicleValue.toString().replace(/[$,.]/g, ''));
        const valueLimit = this.getVehicleValueLimit();
        if (value > valueLimit) {
            this.vehicleValueError = false;
            this.vehicleValueLimitError = true;
        } else {
            this.vehicleValueError = false;
            this.vehicleValueLimitError = false;
        }

        this.formatVehicleValue();
    }
    commercialVehicleUse() {
        if (this.isHeavyVehicle()) {
            this.inspectiosnM.use = 'COMERCIAL';

            this.vehicleUseDisabled = true;
            this.commercialVehicle = true;
            this.valueCheck = false;
        } else {
            this.vehicleUseDisabled = false;
            this.commercialVehicle = false;
        }
    }

    validateDigitalInspection(): { digitalInspection: boolean, reason: string } {
        const result = { digitalInspection: true, reason: '' };
        const activeRules = this.rulesResponse.filter(rule => rule.isActive === true);

        const yearsRule = activeRules.find(rule => rule.keyName === 'ageVehicle');
        const vehicleInsurenceRule = activeRules.find(rule => rule.keyName === 'toleranceInsured');
        const modelsBrandsRule = activeRules.find(rule => rule.keyName === 'brandModels');
        const vehicleTypeUseRule = activeRules.find(rule => rule.keyName === 'typeUseVehicle');
        const vehicleGroupRule = activeRules.find(rule => rule.keyName === 'groupVehicle');
        const provinceCirculationRule = activeRules.find(rule => rule.keyName === 'provinceCirculation');
        const vehicleClassRule = activeRules.find(rule => rule.keyName === 'vehicleClass');

        const validations = {
            insuredValue: { passes: true, reason: '', isActive: !!vehicleInsurenceRule },
            vehicleGroup: { passes: true, reason: '', isActive: !!vehicleGroupRule },
            vehicleType: { passes: true, reason: '', isActive: !!vehicleClassRule },
            vehicleAge: { passes: true, reason: '', isActive: !!yearsRule },
            vehicleUse: { passes: true, reason: '', isActive: !!vehicleTypeUseRule },
            circulationProvince: { passes: true, reason: '', isActive: !!provinceCirculationRule },
            brandModel: { passes: true, reason: '', isActive: !!modelsBrandsRule }
        };

        if (validations.insuredValue.isActive && this.inspectiosnM.vehicleValue) {
            const value = parseFloat(this.inspectiosnM.vehicleValue.toString().replace(/[$,.]/g, ''));
            if (value > parseFloat(vehicleInsurenceRule.keyValue)) {
                validations.insuredValue.passes = false;
                validations.insuredValue.reason = `El valor asegurado (${this.inspectiosnM.vehicleValue}) supera el límite establecido (${vehicleInsurenceRule.keyValue}) para inspecciones digitales.`;
            }
        }

        if (validations.vehicleGroup.isActive && this.inspectiosnM.vehicleGroup && vehicleGroupRule) {
            if (this.inspectiosnM.vehicleGroup.toUpperCase() !== vehicleGroupRule.keyValue.toUpperCase()) {
                validations.vehicleGroup.passes = false;
                validations.vehicleGroup.reason = `El grupo del vehículo (${this.inspectiosnM.vehicleGroup}) no es elegible para inspección digital.`;
            }
        }

        if (validations.vehicleType.isActive && this.inspectiosnM.vehicleType && vehicleClassRule) {
            const normalizedType = this.normalizeString(this.inspectiosnM.vehicleType);
            if (!vehicleClassRule.keyValue.some(tipo => this.normalizeString(tipo) === normalizedType)) {
                validations.vehicleType.passes = false;
                validations.vehicleType.reason = `El tipo de vehículo (${this.inspectiosnM.vehicleType}) no es elegible para inspección digital.`;
            }
        }

        if (validations.vehicleAge.isActive && this.inspectiosnM.yearManufacture) {
            const currentYear = new Date().getFullYear();
            const vehicleYear = parseInt(this.inspectiosnM.yearManufacture);
            const maxYears = parseInt(yearsRule.keyValue);

            if (currentYear - vehicleYear > maxYears) {
                validations.vehicleAge.passes = false;
                validations.vehicleAge.reason = `El vehículo excede la antigüedad máxima permitida (${maxYears} años) para inspección digital.`;
            }
        }

        if (validations.vehicleUse.isActive && this.inspectiosnM.use && vehicleTypeUseRule) {
            if (this.inspectiosnM.use.toUpperCase() !== vehicleTypeUseRule.keyValue.toUpperCase()) {
                validations.vehicleUse.passes = false;
                validations.vehicleUse.reason = `El uso del vehículo (${this.inspectiosnM.use}) no es elegible para inspección digital.`;
            }
        }

        if (validations.circulationProvince.isActive && this.inspectiosnM.provinceCirculation) {
            const isRestricted = this.provincesResponse.some(
                province => province.city.toUpperCase() === this.inspectiosnM.provinceCirculation.toUpperCase()
            );
            if (isRestricted) {
                validations.circulationProvince.passes = false;
                validations.circulationProvince.reason = `La provincia de circulación (${this.inspectiosnM.provinceCirculation}) está restringida para inspección digital.`;
            }
        }

        if (validations.brandModel.isActive && this.inspectiosnM.vehicleBrand && this.inspectiosnM.vehicleModel) {
            const isRestricted = this.vehicleRestrictedResponse.some(
                restriction =>
                    restriction.isActive &&
                    restriction.vehicleBrand.toUpperCase() === this.inspectiosnM.vehicleBrand.toUpperCase() &&
                    this.inspectiosnM.vehicleModel.toUpperCase().includes(restriction.vehicleModel.toUpperCase())
            );
            if (isRestricted) {
                validations.brandModel.passes = false;
                validations.brandModel.reason = `La marca/modelo (${this.inspectiosnM.vehicleBrand} ${this.inspectiosnM.vehicleModel}) está restringida para inspección digital.`;
            }
        }

        const activeValidations = Object.entries(validations).filter(([_, v]) => v.isActive);
        const allValidationsPass = activeValidations.every(([_, v]) => v.passes);
        this.isCurrentInspectionDigital = allValidationsPass;
        const failedValidation = activeValidations.find(([_, v]) => !v.passes);

        return {
            digitalInspection: allValidationsPass,
            reason: failedValidation ? failedValidation[1].reason : ''
        };
    }

    handleQuestionsSubmit(isDigital: boolean) {
        this.isDigitalInspection = isDigital;
        this.showQuestions = false;

        if (isDigital) {
        }

        this.ActiveForm = false;
        this.FinishForm = true;
    }

    handleGoBack() {
        this.showQuestions = false;
        this.ActiveForm = true;
    }

    goForward() {
        this.ActiveForm = true;
        this.showQuestions = false;
    }

    setActiveTab(tab: string) {
    }

    filterVehicleClasses(event) {
        let query = event.query;
        this.filteredVehicleClasses = [];
        if (query) {
            this.filteredVehicleClasses = this.vehicleClassOptions.filter(vehicleClass =>
                vehicleClass.label.toLowerCase().includes(query.toLowerCase()));
        } else {
            this.filteredVehicleClasses = [...this.vehicleClassOptions];
        }
    }

    onVehicleClassSelect(event) {
        if (event && event.value) {
            if (event.grupo) {
                this.inspectiosnM.vehicleGroup = event.grupo;
            }
            if (event.tipo) {
                this.inspectiosnM.vehicleType = event.tipo;
            }

            this.commercialVehicleUse();

            const activeRules = this.rulesResponse.filter(rule => rule.isActive === true);
            const vehicleGroupRule = activeRules.find(rule => rule.keyName === 'groupVehicle');
            const vehicleClassRule = activeRules.find(rule => rule.keyName === 'vehicleClass');

            const cumpleGrupo = this.inspectiosnM.vehicleGroup &&
                this.inspectiosnM.vehicleGroup.toUpperCase() === vehicleGroupRule.keyValue.toUpperCase();

            const cumpleTipo = this.inspectiosnM.vehicleType &&
                vehicleClassRule.keyValue.some(
                    tipo => this.inspectiosnM.vehicleType.toUpperCase() === tipo.toUpperCase()
                );
        }
    }

    isHeavyVehicle(): boolean {
        const commercialRequiredTypes = [
            'CAMION',
            'TRAILER',
            'UNIDAD DE CARGA Y REMOLQUE'
        ];

        const isHeavyByGroup = this.inspectiosnM.vehicleGroup &&
            this.inspectiosnM.vehicleGroup.toUpperCase() === 'PESADO';
        const isCommercialByType = this.inspectiosnM.vehicleType &&
            commercialRequiredTypes.some(type =>
                this.normalizeString(this.inspectiosnM.vehicleType) === this.normalizeString(type));

        const requiresCommercialUse = isHeavyByGroup || isCommercialByType;
        return requiresCommercialUse;
    }

    getVehicleValueLimit(): number {
        if (this.isHeavyVehicle()) {
            return this.heavyVehicleLimit;
        } else {
            return this.ligthVehicleLimit;
        }
    }

    loadInspectionRules() {
        this.inspectionRulesService.getRules().subscribe({
            next: (response) => {
                this.rulesResponse = response;
                const vehicleClassRule = response.find(rule => rule.keyName === 'vehicleClass');
                if (vehicleClassRule && vehicleClassRule.keyValue) {
                }
            },
            error: (error) => {
            }
        });

        this.inspectionRulesService.getProvinces().subscribe({
            next: (response) => {
                this.provincesResponse = response;
            },
            error: (error) => {
            }
        });

        this.inspectionRulesService.getVehicles().subscribe({
            next: (response) => {
                this.vehicleRestrictedResponse = response;
            },
            error: (error) => {
            }
        });
    }
}
